import React from 'react'

import { Avatar } from '@wartek-id/avatar'
import { Text } from '@wartek-id/text'
import {
  Sheet,
  SheetCloseButton,
  SheetContent,
  SheetOverlay,
  SheetBody,
  SheetTitle,
} from '@wartek-id/sheet'

interface ModuleDrawerProps {
  modul: {
    name: string
    description: string
  }
  reviewer: {
    name: string
    imageUrl: string
    about: string
  }
  materials: {
    id: number | string
    name: string
  }[]
  isOpen: boolean
  onSheetClosed: () => void
}

const ModuleDrawer = ({
  modul,
  reviewer,
  materials,
  isOpen = false,
  onSheetClosed = () => {},
}: ModuleDrawerProps) => {
  return (
    <Sheet
      autoFocus={false}
      isOpen={isOpen}
      onClose={onSheetClosed}
      position="bottom"
      returnFocus
      sheetSize="lg"
      type="modal"
    >
      <SheetOverlay />
      <SheetContent>
        <SheetTitle>MODUL</SheetTitle>

        <SheetBody>
          <div className="px-4 min-h-[200px] bg-white">
            <div className="mb-2">
              <Text variant="heading-lg">{modul.name}</Text>
            </div>
            <Text
              as="div"
              className="simple-wysiwyg-content mb-6"
              dangerouslySetInnerHTML={{ __html: modul.description }}
            />
            {materials?.length > 0 && (
              <div className="mb-6">
                <div>
                  <Text variant="heading-sm">Daftar Materi:</Text>
                </div>
                <Text as="p">
                  <ul className="list-disc pl-5">
                    {materials.map((materi) => {
                      return <li key={materi.id}>{materi.name}</li>
                    })}
                  </ul>
                </Text>
              </div>
            )}
            <div className="mb-6">
              <div>
                <Text as="span" variant="heading-sm">
                  Langkah Penyelesaian Modul
                </Text>
              </div>
              <Text as="p">
                <ol className="list-decimal pl-5">
                  <li>Belajar materi</li>
                  <li>Refleksi pembelajaran</li>
                  <li>Post Test</li>
                </ol>
              </Text>
            </div>
            <div className="py-4 border-t border-subdued">
              <div className="flex items-center mb-4">
                <div className="mr-3">
                  <Text variant="body-sm">Dikembangkan oleh</Text>
                  <Text variant="heading-md">{reviewer.name}</Text>
                </div>
                <div className="ml-auto">
                  <Avatar
                    alt=""
                    shape="circle"
                    size="md"
                    src={reviewer.imageUrl}
                  />
                </div>
              </div>
              <div>
                <Text>{reviewer.about}</Text>
              </div>
            </div>
          </div>
        </SheetBody>
        <SheetCloseButton data-testid="close-drawer" onClick={onSheetClosed} />
      </SheetContent>
    </Sheet>
  )
}

export default ModuleDrawer
